import { useCallback, useMemo } from 'react';
import { useListContext } from '../list-context';
import { useNestedList } from './use-nested-list';
/**
 * @private
 */
export function useListItem(props) {
  var _listContext$selectab;
  const listContext = useListContext(ctx => ({
    selectionMode: ctx.selectionMode,
    selectable: ctx.selectable,
    size: ctx.size
  }));
  const contextSelected = useListContext(ctx => {
    var _ctx$selectedValues$h, _ctx$selectedValues;
    return (_ctx$selectedValues$h = (_ctx$selectedValues = ctx.selectedValues) == null ? void 0 : _ctx$selectedValues.has(props.value)) != null ? _ctx$selectedValues$h : false;
  });
  const contextOnClick = useListContext(ctx => ctx.onClick);
  const contextOnSelect = useListContext(ctx => ctx.onSelect);
  const {
    selected = contextSelected != null ? contextSelected : false,
    selectable = (_listContext$selectab = listContext.selectable) != null ? _listContext$selectab : false,
    iconLeft = selectable && listContext.selectionMode ? defauitIconBySelectionMode[listContext.selectionMode] : null,
    disabled = false,
    onClick: propsOnClick,
    onSelect: propsOnSelect,
    value,
    adornmentRight,
    description,
    text,
    children,
    badgeValue,
    iconRight = null
  } = props;
  const nestedList = useNestedList();
  const {
    textid,
    descriptionId,
    itemId
  } = useMemo(() => ({
    itemId: `li_${value}`,
    textid: `litext_${value}`,
    descriptionId: `lidesc_${value}`
  }), [value]);
  const onSelect = useCallback(() => {
    if (!selectable) return;
    propsOnSelect == null ? void 0 : propsOnSelect(value);
    contextOnSelect == null ? void 0 : contextOnSelect([value]);
  }, [contextOnSelect, value, selectable, propsOnSelect]);
  const onClick = useCallback(() => {
    if (disabled) return;
    onSelect();
    propsOnClick == null ? void 0 : propsOnClick(value);
    contextOnClick == null ? void 0 : contextOnClick(value);
  }, [onSelect, disabled, contextOnClick, propsOnClick, value]);
  const onKeyDown = useCallback(e => {
    if (e.key === ' ' || e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      onClick();
    }
  }, [onClick]);
  const iconSize = listContext.size === 'm' ? 20 : 24;
  return {
    selected,
    disabled,
    textid,
    descriptionId,
    itemId,
    badgeValue,
    iconLeft,
    iconRight,
    text,
    description,
    adornmentRight,
    children,
    onClick,
    onKeyDown,
    value,
    selectable,
    isInteractive: selectable || props.onClick || contextOnClick,
    size: listContext.size,
    currentPadding: nestedList.currentPaddingStart,
    nextPadding: nestedList.nextPaddingStart,
    iconSize
  };
}
const defauitIconBySelectionMode = {
  none: null,
  multiple: 'checkbox',
  single: 'radio'
};